import React from "react";
import "./Carousel.css";
import PeekCarousel from "./PeekCarousel/PeekCarousel";

const slides = [
    {
        image: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/carousel/vivi-tranquilo.webp",
        title: (
            <>
                Viví<br/>tranquilo
            </>
        ),
        body: "Asegurate con los mejores expertos.",
        buttonText: "Cotizar ahora",
    },
    {
        image: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/carousel/certificacion.webp",
        title: (
            <>
                <br/>Certificación
            </>
        ),
        body: "Tu seguridad es nuestra prioridad.",
        buttonText: "Cotizar ahora",
        imgClass: "slide-certificacion"
    },
    {
        image: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/carousel/apoyo-a-la-hora-del-siniestro.webp",
        title: (
            <>
                Apoyo en<br/>siniestros

            </>
        ),
        body: "Estamos a tu lado en todo momento.",
        buttonText: "Cotizar ahora",
    },
    {
        image: "https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/carousel/mejores-precios.webp",
        title: (
            <>
                Mejores<br/>precios

            </>
        ),
        body: "Asegurate con las mejores tarifas del mercado.",
        buttonText: "Cotizar ahora",
    }
];

function Carousel() {
    return (
        <div className="clientes__carousel__container">
            <PeekCarousel slides={slides}/>
        </div>
    );
}

export default Carousel;
